module.exports = __webpack_public_path__ + "static/media/7.97ca580a.svg";